import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loggedout',
  templateUrl: './loggedout.component.html',
  styleUrls: ['./loggedout.component.css']
})
export class LoggedOutComponent implements OnInit {

    year: number = new Date().getFullYear();
  constructor() { }

  ngOnInit(): void {
  }

}
